import { TabRouteType } from '@dfl/react-security';
import { SettingsIcon, AreaIcon, UserIcon } from 'components/SvgIcons';
import { TabLabel } from 'modules/common/components/TabLabel';

export const establishmentTabs: TabRouteType[] = [
  {
    path: '/client/:id/establishment/:establishmentId/general',
    to: '/general',
    label: 'tabs.general',
    render: () => <TabLabel Icon={SettingsIcon} label={'tabs.general'} ns={'establishment'} />,
  },
  {
    path: '/client/:id/establishment/:establishmentId/area',
    to: '/area',
    label: 'tabs.area',
    render: () => <TabLabel Icon={AreaIcon} label={'tabs.area'} ns={'establishment'} />,
  },
  {
    path: '/client/:id/establishment/:establishmentId/users',
    to: '/users',
    label: 'tabs.users',
    permissions: ['USER_WRITE'],
    render: () => <TabLabel Icon={UserIcon} label={'tabs.users'} ns={'client'} />,
  },
];
